import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getRequirementList = (payload, callback) =>
  req.list(
    c.GET_REQUIREMENT,
    '/api/v1/administrators/system_modules',
    payload,
    callback
  );

export const showRequirement = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_MODULE,
    `/api/v1/administrators/system_modules/${id}`,
    payload,
    callback
  );

export const createRequirement = (payload, callback) =>
  req.create(
    c.CREATE_REQUIREMENT,
    '/api/v1/administrators/system_modules',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateRequirement = (id, payload, callback) =>
  req.update(
    c.UPDATE_REQUIREMENT,
    `/api/v1/administrators/system_modules/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeRequirement = (id, payload, callback) =>
  req.remove(
    c.REMOVE_REQUIREMENT,
    `/api/v1/administrators/system_modules/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Untag !');
      if (callback) callback();
    }
  );

export const createApplicationStatus = (payload, callback) =>
  req.create(
    c.CREATE_APPLICATION_STATUS,
    `/api/v1/administrators/module_systems/${payload.system_module_id}/application_statuses`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateApplicationStatus = (payload, callback) =>
  req.update(
    c.UPDATE_REQUIREMENT,
    `/api/v1/administrators/module_systems/${payload.system_module_id}/application_statuses/${payload.id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );


export const removeApplicationStatus = (payload, callback) =>
  req.remove(
    c.REMOVE_APPLICATION_STATUS,
    `/api/v1/administrators/module_systems/${payload.system_module_id}/application_statuses/${payload.id}`,
    () => {
      if (callback) callback();
    }
  );